<template>
  <PageSection
    class="training-section-info-blocks"
  >
    <template #default>
      <div class="container">
        <h2
          v-if="title"
          class="title"
          v-inview-animate:once="{name: 'fade-down', duration: 500, delay: 300}"
          v-html="title"
        ></h2>
        <div
          v-if="infoBlocks && infoBlocks.length"
          class="info-blocks-grid"
          v-inview-animate:once="{name: 'fade-down', duration: 500, delay: 400}"
        >
          <TrainingSectionInfoBlockItem
            v-for="(block, index) in infoBlocks"
            :key="`info-block-${index}`"
            :image="block.Image"
            :image-mobile="block.ImageMobile"
            :title="block.Title"
            :text="block.Text"
            :image-position="block.ImagePosition"
          />
        </div>
      </div>
    </template>
  </PageSection>
</template>

<script>
import PageSection from '@/components/PageSection.vue';
import TrainingSectionInfoBlockItem from './TrainingSectionInfoBlockItem.vue';

export default {
  name: 'TrainingSectionInfoBlocks',
  components: {
    PageSection,
    TrainingSectionInfoBlockItem,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    infoBlocks: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.training-section-info-blocks {
  @include wRule(
    padding-top,
    (
      xl: 120,
      lg: 100,
      md: 80,
      sm: 80,
    )
  );

  @include wRule(
    padding-bottom,
    (
      xl: 120,
      lg: 100,
      md: 80,
      sm: 80,
    )
  );

  .title {
    display: block;
    width: 100%;
    text-align: center;
    font-weight: 700;
    line-height: 1.2;

    @include wRule(
      font-size,
      (
        xl: 48,
        lg: 42,
        md: 36,
        sm: 48,
      )
    );

    &:not(:last-child) {
      @include wRule(
        margin-bottom,
        (
          xl: 60,
          lg: 50,
          md: 40,
          sm: 50,
        )
      );
    }
  }

  .info-blocks-grid {
    display: flex;
    flex-direction: column;
    gap: 0;
  }

  // Адаптивные отступы между блоками
  .info-blocks-grid > *:not(:last-child) {
    @include wRule(
      margin-bottom,
      (
        xl: 140,
        lg: 100,
        md: 0,
        sm: 0,
      )
    );

    // Горизонтальный сепаратор между блоками на md/sm
    @include screen("md", max) {
      @include wRule(
        padding-bottom,
        (
          md: 40,
          sm: 30,
        )
      );
      border-bottom: 2px solid #14181f;
      @include wRule(
        margin-bottom,
        (
          md: 40,
          sm: 30,
        )
      );
    }
  }
}
</style>
